import type { FaireProductEntity } from "../../entity_types/product";

export const p_kuyzbp7eek: FaireProductEntity = {
  token: "p_kuyzbp7eek",
  type: "product",
  name: "Arizona Dragonfruit Mango 24/22OZ",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/221e9e141a7796060c9b025e45e9fe6b580c6b35cae5747407ac6731326fa9e3.jpeg",
  galleryImageUrls: [],
  priceDollars: 34.64,
  description:
    "A tropical fusion of sweet mango and exotic dragonfruit flavors. Arizona Dragonfruit Mango delivers bold refreshment in 22oz cans. Sold in a 24-pack—great for coolers, summer promotions, and fruit-forward beverage sets.\n\n",
  tags: [],
  msrpDollars: 69.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:50.269Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
